export default __webpack_public_path__ + "static/media/ico_home_disabled.1ece5a70.svg";